if($('.type-category.desktop').length){
    $(document).ready(function() {
        perexMove();
       
    });
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        perexMove();
       
    });
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        perexMove();
        
    });
    function perexMove(){
        $(function() {
            const currentPath = window.location.pathname.replace(/\/+$/, '/')
            if (!categoryBackgrounds[currentPath]) return;
            if($('.category-header-wrap').length>0) return;
            if ($('.category-title').length) {
                const bgImage = categoryBackgrounds[currentPath];
                const $title = $('.category-title');
                const $perex = $('.category-perex:not(.empty-content)');
                const $wrap = $('<div class="category-header-wrap"><div class="container"></div></div>');
                const $content = $('<div class="category-header-content"></div>');
                const $breadcrumbs = $('.breadcrumbs-wrapper').length ? $('.breadcrumbs-wrapper') : '';
                $title.add($perex).wrapAll($content);
                $('.category-header-content').wrap($wrap);
                $('.category-header-wrap .container').prepend($breadcrumbs);
                $('.category-header-wrap').attr('style', 'background:rgba(0,0,0,0.2) url('+bgImage+')');
                $('.category-header-wrap').insertAfter('header');
            }
        });
    }
}